import dateFormat from "./dateFormat.filter";

const dateFormatModule = angular
  .module("app.filters.dateFormat", [])
  .filter("dateFormat", dateFormat);

export default dateFormatModule;



// WEBPACK FOOTER //
// ./src/filters/dateFormat/dateFormat.module.js